import { breakpoints } from '@gto/ui/theme/design-tokens'

export type BreakpointName = keyof typeof breakpoints

export type BreakpointValue = BreakpointName | number

const DIRECTIONS = ['up', 'down', 'between'] as const

type Direction = (typeof DIRECTIONS)[number]

function resolveBreakpoint(value: BreakpointValue): number {
  return typeof value === 'number' ? value : breakpoints[value]
}

/** Viewports **at or above** the breakpoint. E.g. `mediaUp('sm')` → `(min-width:640px)` */
export function mediaUp(breakpoint: BreakpointValue): string {
  return `(min-width:${resolveBreakpoint(breakpoint)}px)`
}

/** Viewports **narrower than** the breakpoint. E.g. `mediaDown('sm')` → `(max-width:639.95px)` */
export function mediaDown(breakpoint: BreakpointValue): string {
  return `(max-width:${resolveBreakpoint(breakpoint) - 0.05}px)`
}

/** Viewports **between** two breakpoints (inclusive start, exclusive end). */
export function mediaBetween(start: BreakpointValue, end: BreakpointValue): string {
  return `(min-width:${resolveBreakpoint(start)}px) and (max-width:${resolveBreakpoint(end) - 0.05}px)`
}

export function isDirection(value: string): value is Direction {
  return DIRECTIONS.some((d) => d === value)
}

/** Imperative counterpart to `useMediaQuery('(prefers-reduced-motion: reduce)')` — safe to call inside effects. */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

/** Imperative check for a hover-capable, precise pointer (mouse/trackpad rather than touch). */
export function isFinePointer(): boolean {
  return (
    typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches
  )
}
